import axios from 'axios';
import { api } from "../includes";

export const postmaster = (path, params) => {
    const promise = new Promise((resolve, reject) => {
        axios.post(api + path, params).then((result) => {
            resolve(result.data);
        }, (err) => {
            reject(err);
        });
    });
    return promise;
}